// axios 发送ajax请求
import request from '@/utils/request'

export default{

  //查询商品列表
  list() {
    return request({
      url: '/public/api/product/list',
      method: 'get'
    })
  },
  list1() {
    return request({
      url: '/public/api/product/list1',
      method: 'get'
    })
  },
  listYB() {
    return request({
      url: '/public/api/product/listyb',
      method: 'get'
    })
  },
  listYB1() {
    return request({
      url: '/public/api/product/listyb1',
      method: 'get'
    })
  }
}
